import { createFileRoute } from '@tanstack/react-router'

import { WorkItemsPage } from '@/pages/batches/WorkItems.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/work-items',
)({
  component: WorkItemsPage,
  loader: () => ({ breadcrumbTitle: 'Work Items' }),
})
